import { axios } from '@/utils/request'

export function getCloudCardList (queryParam) {
  return axios({
    url: '/mycloud/list',
    method: 'get',
    params: queryParam
  })
}

export function getCardList (queryParam) {
  return axios({
    url: '/CardCode/list',
    method: 'get',
    params: queryParam
  })
}

export function putObj (obj) {
  return axios({
    url: '/CardCode',
    method: 'put',
    data: obj
  })
}

export function getCard (queryParam) {
  return axios({
    url: '/CardCode/cardlist',
    method: 'get',
    params: queryParam
  })
}

export function delObj (id) {
  return axios({
    url: '/CardOrder/deleteOrder/' + id,
    method: 'delete'
  })
}
